// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/.store/css-loader@3.6.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".saas-model .el-dialog__body{max-height:60vh;overflow:auto}.saas-model .el-form-item{margin-bottom:1rem}", ""]);
// Exports
module.exports = exports;
